// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3BgTi","clinicsSelect":"TableHeading_clinicsSelect__Lr_0Z"};